import { Injectable } from '@angular/core';
import { BehaviorSubject, debounceTime, fromEvent, merge } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DeviceOrientationService {
  private isTabletSubject = new BehaviorSubject<boolean>(false);
  private isPortraitSubject = new BehaviorSubject<boolean>(false);
  private showWarningSubject = new BehaviorSubject<boolean>(false);

  public isTablet$ = this.isTabletSubject.asObservable();
  public isPortrait$ = this.isPortraitSubject.asObservable();
  public showWarning$ = this.showWarningSubject.asObservable();

  constructor() {
    this.checkDevice();
    this.setupListeners();
  }

  private setupListeners() {
    merge(fromEvent(window, 'resize'), fromEvent(window, 'orientationchange'))
      .pipe(debounceTime(100))
      .subscribe(() => this.checkDevice());
  }

  private checkDevice() {
    const width = window.innerWidth;
    const height = window.innerHeight;
    const userAgent = navigator.userAgent.toLowerCase();

    const isUserAgentTablet =
      /ipad|tablet|playbook|silk|android(?!.*mobile)|kindle/i.test(userAgent);

    const isSizeTablet =
      (width >= 768 && width <= 1400) || (height >= 768 && height <= 1400);

    const hasTouchSupport =
      'ontouchstart' in window || navigator.maxTouchPoints > 0;

    const isTablet = isUserAgentTablet || (isSizeTablet && hasTouchSupport);

    const isPortrait = height > width;

    this.isTabletSubject.next(isTablet);
    this.isPortraitSubject.next(isPortrait);
    this.showWarningSubject.next(isTablet && isPortrait);
  }

  public get isTablet(): boolean {
    return this.isTabletSubject.value;
  }

  public get isPortrait(): boolean {
    return this.isPortraitSubject.value;
  }

  public get showWarning(): boolean {
    return this.showWarningSubject.value;
  }
}
